import { styled } from '@uhg-abyss/web/tools/styled';

export const Styles: ReturnType<typeof styled> = styled('div', {
  marginLeft: 'var(--abyss-space-md)',
  marginRight: 'var(--abyss-space-xs)',
});
